import React from 'react';
import {Card,CardContent,Grid,Typography} from '@mui/material';
import {InvestmentBudgetHeader} from './investmentbudget.models';

const money=(v:number)=>
  Number(v||0).toLocaleString(
    undefined,
    {maximumFractionDigits:0},
  );

export default class InvestmentBudgetSummary
extends React.PureComponent<{value:InvestmentBudgetHeader}>{
  render(){
    const v=this.props.value;

    const cards=[
      ['Ceiling',money(v.ceilingamount)],
      ['Requested',money(v.requestedamount)],
      ['Available',money(v.availableamount)],
      ['Utilisation',`${v.utilisationpercent.toFixed(1)}%`],
      ['Recurring Impact',money(v.recurringcostimpact)],
      ['Lines',String(v.linecount)],
    ];

    return (
      <Grid container spacing={2}>
        {cards.map(([label,value])=>(
          <Grid size={{xs:12,sm:6,md:2}} key={label}>
            <Card variant="outlined">
              <CardContent>
                <Typography
                  variant="caption"
                  color="text.secondary"
                >
                  {label}
                </Typography>
                <Typography
                  variant="h6"
                  fontWeight={700}
                >
                  {value}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }
}
